export default __webpack_public_path__ + "static/media/kp.73418fae.svg";